const NotFoundPage = () => {
  return <div className='not-found-page-container'>页面没找到</div>
}

export default NotFoundPage
